import {
  useAlertsManagementListFilter,
  useSetAlertsManagementListFilter,
} from '@gripp/shared-logic';
import {
  AlertsManagementSearchInput,
  countFilters,
  FilterHeaders,
  SlideAction,
  useSlideLayout,
  ViewMode,
} from '@gripp/shared-ui';
import { StyleSheet, View } from 'react-native';
import { useNavigate } from 'react-router-dom';

export const AlertsManagementFilters = () => {
  const navigate = useNavigate();
  const { currentViewMode, onSlideChange } = useSlideLayout();

  const { data: alertsFilter } = useAlertsManagementListFilter();
  const { mutateAsync: setAlertsFilter } = useSetAlertsManagementListFilter();
  const filterCount = countFilters(alertsFilter);

  const onFilterNavigate = async () => {
    if (currentViewMode === ViewMode.SINGLE) {
      await onSlideChange(SlideAction.DUAL);
    }
    navigate('/alerts-management/filters');
  };

  return (
    <View style={styles.filtersContainer}>
      <FilterHeaders
        currentSearchKeyword={alertsFilter?.keyword}
        searchComponent={<AlertsManagementSearchInput />}
        onFilterPress={onFilterNavigate}
        onSearchClose={() => setAlertsFilter({ keyword: '' })}
        filterCount={filterCount}
        Routes={{}}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  filtersContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 12,
  },
});
